import React from 'react';
import { mediaQuery } from '../../util/ui';
import PinterestIcon from 'mdi-react/PinterestIcon';
import FacebookBoxIcon from 'mdi-react/FacebookBoxIcon';
// import InstagramIcon from 'mdi-react/InstagramIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import WhatsappIcon from 'mdi-react/WhatsappIcon';

import TwitterIcon from 'mdi-react/TwitterIcon';
import PrinterIcon from 'mdi-react/PrinterIcon';
import { withTranslation } from 'next-i18next';
import { WithTranslation as WithTranslationType } from 'next-i18next';
import {
  EmailShareButton,
  FacebookShareButton,
  WhatsappShareButton,
  PinterestShareButton,
  TwitterShareButton,
} from 'react-share';
import { PartialRecipe } from '../../types/api/entities/recipe';
import { getMainImage } from '../../util/image';

export interface MediaBarProps {
  onPrintClick(): void;
  recipe: PartialRecipe;
  url: string;
}

export class _MediaBar extends React.PureComponent<MediaBarProps & WithTranslationType> {
  public render() {
    const shareUrl = this.props.url;

    const mainImage = getMainImage(this.props.recipe.media);

    return (
      <div className="media">
        <a className="media-link">
          {mainImage && (
            <PinterestShareButton
              url={shareUrl}
              media={mainImage.urls['1x1'].L}
              description={this.props.recipe.name}
            >
              <span className="media-button">
                <PinterestIcon color="#c30200" />
                <span>Pinterest</span>
              </span>
            </PinterestShareButton>
          )}
        </a>

        <a className="media-link">
          <FacebookShareButton url={shareUrl} quote={this.props.recipe.name}>
            <span className="media-button">
              <FacebookBoxIcon color="#4464a2" />
              <span>Facebook</span>
            </span>
          </FacebookShareButton>
        </a>

        <a className="media-link">
          <EmailShareButton
            url={shareUrl}
            subject={this.props.recipe.name}
            body={'Check this recipe out:'}
          >
            <span className="media-button">
              <EmailIcon color="#313131" />
              <span>Email</span>
            </span>
          </EmailShareButton>
        </a>

        <a className="media-link">
          <TwitterShareButton url={shareUrl} title={this.props.recipe.name}>
            <span className="media-button">
              <TwitterIcon color="#21abf4" />
              <span>Twitter</span>
            </span>
          </TwitterShareButton>
        </a>
        <a className="media-link">
          <WhatsappShareButton url={shareUrl}>
            <span className="media-button">
              <WhatsappIcon color="#4FCE5E" />
              <span>Whatsapp</span>
            </span>
          </WhatsappShareButton>
        </a>

        <a className="media-link media-link_print" onClick={this.props.onPrintClick}>
          <span className="media-button">
            <PrinterIcon color="#313131" />
            <span>{this.props.t('PrintRecipe')}</span>
          </span>
        </a>

        <style jsx>{`
          .media-link,
          .media-button {
            cursor: pointer;
          }

          .media-link {
            text-decoration: none;
          }

          .media-button {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 44px;
            height: 44px;
            border-radius: 4px;
            background-color: #f2f2f2;
            border: none;
            box-sizing: border-box;
          }

          .media-button span {
            display: none;
          }

          .media-button span {
            margin-left: 10px;
            font-family: var(--font-family-primary);
            font-size: 15px;
            line-height: normal;
            color: #343434;
          }

          .media-link:not(:first-child) {
            margin-left: 12px;
          }

          @media ${mediaQuery.ExtraLarge} {
            .media-button {
              width: auto;
              padding: 0 15px;
              display: inline-flex;
              align-items: center;
            }

            .media-link:not(:first-child) {
              margin-left: 10px;
            }

            .media-button span {
              display: inline;
            }
          }
        `}</style>
      </div>
    );
  }
}

export const MediaBar = withTranslation()(_MediaBar);
